/**
 * The module a tab is operating in. This is the routing identity (3 values);
 * consumers derive narrower values from it (auth scope for storage, the request
 * context header, include params).
 */
export enum AppModule {
  BrokerPortal = 'broker-portal',
  MiddleOffice = 'middle-office',
  Application = 'application',
}
